(function () {
  'use strict';

  var patchSelectors = [
    '.edit-cart-summary',
    '.edit-bundle-cart-status',
    '.edit-cart-trust'
  ];

  var syncTimer = null;
  var syncToken = 0;
  var pendingExpected = null;

  function intValue(value, fallback) {
    var n = parseInt(value, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function money(cents) {
    var amount = Math.max(0, intValue(cents, 0)) / 100;
    return 'Rs.' + amount.toLocaleString('en-PK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function getQuantityInput(control) {
    if (!control || !control.closest) return null;
    var wrapper = control.closest('[data-quantity-wrapper]');
    return wrapper ? wrapper.querySelector('[data-quantity-value]') : null;
  }

  function expectedFromControl(control) {
    if (!control) return null;

    if (control.matches('[data-cart-remove]')) {
      return {
        key: control.getAttribute('data-id'),
        quantity: 0,
        at: Date.now()
      };
    }

    var input = getQuantityInput(control);
    if (!input) return null;

    var key = input.getAttribute('data-id');
    var current = intValue(input.value, 0);
    var step = Math.max(1, intValue(input.getAttribute('step'), 1));
    var min = intValue(input.getAttribute('min'), 0);
    var maxRaw = input.getAttribute('max');
    var max = maxRaw ? intValue(maxRaw, Number.MAX_SAFE_INTEGER) : Number.MAX_SAFE_INTEGER;

    var base = current;
    if (
      pendingExpected &&
      pendingExpected.key === key &&
      Date.now() - pendingExpected.at < 1500
    ) {
      base = pendingExpected.quantity;
    }

    var quantity = base;
    if (control.matches('[data-increase-qty]')) {
      quantity = Math.min(max, base + step);
    } else if (control.matches('[data-decrease-qty]')) {
      quantity = Math.max(min, base - step);
    }

    return { key: key, quantity: quantity, at: Date.now() };
  }

  function expectedFromInput(input) {
    if (!input) return null;
    return {
      key: input.getAttribute('data-id'),
      quantity: intValue(input.value, 0),
      at: Date.now()
    };
  }

  function getPredictedCart(expected) {
    var lines = Array.prototype.slice.call(
      document.querySelectorAll('[data-cart-wrapper] [data-cart-item]')
    );

    var originalSubtotal = 0;
    var eligibleSubtotal = 0;
    var eligibleQty = 0;

    lines.forEach(function (line) {
      var input = line.querySelector('[data-quantity-value]');
      if (!input) return;

      var key = input.getAttribute('data-id');
      var qty = intValue(input.value, 0);

      if (expected && expected.key === key) {
        qty = expected.quantity;
      }

      if (qty <= 0) return;

      var unitPrice = intValue(
        line.getAttribute('data-edit-original-unit-price'),
        0
      );
      var isEligible =
        line.getAttribute('data-edit-bundle-eligible') === 'true';

      originalSubtotal += unitPrice * qty;

      if (isEligible) {
        eligibleQty += qty;
        eligibleSubtotal += unitPrice * qty;
      }
    });

    var bundleDiscount = eligibleQty >= 2
      ? Math.round(eligibleSubtotal * 0.10)
      : 0;

    var subtotal = Math.max(0, originalSubtotal - bundleDiscount);

    var summary = document.querySelector('.edit-cart-summary');
    var threshold = summary
      ? intValue(summary.getAttribute('data-edit-free-threshold'), 500000)
      : 500000;
    var deliveryCharge = summary
      ? intValue(summary.getAttribute('data-edit-delivery-charge'), 30000)
      : 30000;

    var delivery = subtotal >= threshold ? 0 : deliveryCharge;
    var estimated = subtotal + delivery;

    return {
      originalSubtotal: originalSubtotal,
      bundleDiscount: bundleDiscount,
      subtotal: subtotal,
      eligibleQty: eligibleQty,
      eligibleSubtotal: eligibleSubtotal,
      threshold: threshold,
      delivery: delivery,
      estimated: estimated
    };
  }

  function renderOptimistic(expected) {
    var data = getPredictedCart(expected);
    var summary = document.querySelector('.edit-cart-summary');

    if (summary) {
      var prices = summary.querySelector('[data-cart-prices]');
      if (prices) {
        prices.innerHTML = '';

        if (data.bundleDiscount > 0) {
          var original = document.createElement('div');
          original.className = 't4s-cart__originalPrice';
          original.textContent = money(data.originalSubtotal);

          var discount = document.createElement('div');
          discount.className = 't4s-cart__discountPrice';
          discount.textContent = '- ' + money(data.bundleDiscount);

          prices.appendChild(original);
          prices.appendChild(discount);
        }

        var total = document.createElement('div');
        total.className = 't4s-cart__totalPrice';
        total.textContent = money(data.subtotal);
        prices.appendChild(total);
      }

      var rows = summary.querySelectorAll('.edit-cart-summary-row');
      if (rows[1]) {
        var deliveryValue = rows[1].querySelector('.edit-cart-summary-value');
        if (deliveryValue) {
          deliveryValue.innerHTML = '<strong>' +
            (data.delivery === 0 ? 'FREE' : money(data.delivery)) +
            '</strong>';
        }
      }

      if (rows[2]) {
        var estimatedValue = rows[2].querySelector('.edit-cart-summary-value');
        if (estimatedValue) {
          estimatedValue.innerHTML = '<strong>' + money(data.estimated) + '</strong>';
        }
      }

      summary.classList.add('is-edit-predicted');
    }

    var bundle = document.querySelector('.edit-bundle-cart-status');
    if (bundle) {
      var title = bundle.querySelector('.edit-bundle-cart-status__title');
      var body =
        bundle.querySelector('.edit-bundle-cart-status__success') ||
        bundle.querySelector('.edit-bundle-cart-status__progress');
      var saving = bundle.querySelector('.edit-bundle-cart-status__saving');
      var small = bundle.querySelector('small');

      if (!body) {
        body = document.createElement('div');
        bundle.insertBefore(body, small || null);
      }

      if (title) title.textContent = 'Build Your Bundle';

      if (data.bundleDiscount > 0) {
        body.className = 'edit-bundle-cart-status__success';
        body.textContent = '10% Bundle Discount Applied ✓';

        if (!saving) {
          saving = document.createElement('div');
          saving.className = 'edit-bundle-cart-status__saving';
          if (small) bundle.insertBefore(saving, small);
          else bundle.appendChild(saving);
        }
        saving.textContent = 'You saved ' + money(data.bundleDiscount);
      } else {
        body.className = 'edit-bundle-cart-status__progress';

        if (data.eligibleQty === 1) {
          body.textContent = 'Add 1 more eligible item to unlock 10% off.';
        } else if (data.eligibleQty >= 2) {
          body.textContent = '10% bundle offer unlocked.';
        } else {
          body.textContent = 'Buy any 2+ eligible styles & save 10% automatically.';
        }

        if (saving) saving.remove();
      }

      bundle.classList.add('is-edit-predicted');
    }

    var trust = document.querySelector('.edit-cart-trust');
    if (trust) {
      var freeMsg = trust.querySelector('.edit-free-delivery-msg');
      if (freeMsg) {
        if (data.delivery === 0) {
          freeMsg.className = 'edit-free-delivery-msg is-unlocked';
          freeMsg.textContent = '✓ FREE delivery unlocked.';
        } else {
          freeMsg.className = 'edit-free-delivery-msg';
          freeMsg.textContent =
            'Add ' + money(data.threshold - data.subtotal) +
            ' more to unlock FREE delivery.';
        }
      }

      trust.classList.add('is-edit-predicted');
    }
  }

  function fetchCartJson() {
    return fetch('/cart.js?_edit_sync=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart JSON request failed');
      return res.json();
    });
  }

  function cartMatchesExpected(cart, expected) {
    if (!expected || !expected.key) return true;

    var item = (cart.items || []).find(function (it) {
      return it.key === expected.key;
    });

    if (expected.quantity === 0) return !item;
    return !!item && item.quantity === expected.quantity;
  }

  function waitForCart(expected, token, attempt) {
    attempt = attempt || 0;

    if (token !== syncToken) {
      return Promise.reject(new Error('stale'));
    }

    return fetchCartJson().then(function (cart) {
      if (token !== syncToken) throw new Error('stale');

      if (cartMatchesExpected(cart, expected)) {
        return cart;
      }

      if (attempt >= 35) {
        throw new Error('Cart quantity did not settle in time');
      }

      return new Promise(function (resolve) {
        setTimeout(resolve, 100);
      }).then(function () {
        return waitForCart(expected, token, attempt + 1);
      });
    });
  }

  function fetchFreshCartPage(token) {
    var url = new URL(window.location.href);
    url.hash = '';
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections');
    url.searchParams.set('_edit_sync', Date.now().toString());

    return fetch(url.toString(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'text/html' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Fresh cart page request failed');
        return res.text();
      })
      .then(function (html) {
        if (token !== syncToken) throw new Error('stale');
        return html;
      });
  }

  function patchBlocks(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var patched = 0;

    patchSelectors.forEach(function (selector) {
      var current = document.querySelector(selector);
      var fresh = doc.querySelector(selector);

      if (!current || !fresh) return;

      current.replaceWith(fresh);
      patched += 1;
    });

    if (!patched) {
      throw new Error('Fresh cart blocks were not found');
    }

    document.dispatchEvent(new CustomEvent('edit:cart-summary-updated'));
  }

  function runSync(expected) {
    clearTimeout(syncTimer);

    syncTimer = setTimeout(function () {
      var token = ++syncToken;
      var target = expected || pendingExpected;

      waitForCart(target, token, 0)
        .then(function () {
          return new Promise(function (resolve) {
            setTimeout(resolve, 120);
          });
        })
        .then(function () {
          return fetchFreshCartPage(token);
        })
        .then(function (html) {
          patchBlocks(html);
          pendingExpected = null;
        })
        .catch(function (err) {
          if (err && err.message === 'stale') return;
          console.warn('[edit.] cart server reconciliation failed', err);
        });
    }, 50);
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest &&
      event.target.closest(
        '[data-cart-wrapper] [data-quantity-selector], ' +
        '[data-cart-wrapper] [data-cart-remove]'
      );

    if (!control) return;

    pendingExpected = expectedFromControl(control);

    // Immediate visual response. Shopify's server calculation follows in background.
    renderOptimistic(pendingExpected);
    runSync(pendingExpected);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target.closest &&
      event.target.closest('[data-cart-wrapper] [data-action-change]');

    if (!input) return;

    pendingExpected = expectedFromInput(input);
    renderOptimistic(pendingExpected);
    runSync(pendingExpected);
  }, true);

  if (window.jQuery) {
    window.jQuery(document.body).on('change:ajaxCart', function () {
      runSync(pendingExpected);
    });
  }

  var items = document.querySelector('[data-cart-items]');
  if (items && window.MutationObserver) {
    new MutationObserver(function () {
      if (pendingExpected) runSync(pendingExpected);
    }).observe(items, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  document.addEventListener('edit:cart-force-sync', function () {
    if (pendingExpected) renderOptimistic(pendingExpected);
    runSync(pendingExpected);
  });
})();